<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Client GST Sales Data <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> 
				<span><img src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
				Export
				</button>
				<!-- <button class="addBTn" (click)="addNewHomePageVideo()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Video</button> -->
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadUsers($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="p2-table-columns show-columns" #dt [value]="gstDataList" [paginator]="true"
						[rows]="10" [lazy]="true" (onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords"
						[loading]="loading" [rowsPerPageOptions]="paginationOption" paginatorPosition="bottom"
						styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="gstDataList.gstin" class="col-width gstTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										GSTIN
										<p-sortIcon field="gstin"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gstDataList.name" class="gstDataListTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Academy Name
										<p-sortIcon field="name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gstDataList.address" class="addressTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Address
										<p-sortIcon field="address"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gstDataList.cityname" class="cityNameTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										City
										<p-sortIcon field="cityname"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gstDataList.statename" class="col-width stateNameTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										State
										<p-sortIcon field="statename"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gstDataList.zipcode" class="col-width zipcodeTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										PIN Code
										<p-sortIcon field="zipcode"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="col-width createTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created At
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th class="col-width actionTD p-frozen-column"> 
										Action
									 
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="gstin" class="gstTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstin', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['gstin'] ? dt.filters['gstin'].value : ''" />
								</th>
								<th [ngSwitch]="name" class="gstDataListTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
								</th>
								<th [ngSwitch]="address" class="addressTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'address', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['address'] ? dt.filters['address'].value : ''" />
								</th>
								<th [ngSwitch]="cityname" class="cityNameTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'cityname', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['cityname'] ? dt.filters['cityname'].value : ''" />
								</th>
								<th [ngSwitch]="statename" class="stateNameTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'statename', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['statename'] ? dt.filters['statename'].value : ''" />
								</th>
								<th [ngSwitch]="zipcode" class="zipcodeTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'zipcode', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['zipcode'] ? dt.filters['zipcode'].value : ''" />
								</th>
								<th [ngSwitch]="created_at" class="createTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<!-- <input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'created_at', 'contains')"
								style="width: 90px;"
								[value]="dt.filters['created_at'] ? dt.filters['created_at'].value : ''" /> -->
								</th>

									<th class="actionTD p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-gstList>
							<tr class="p-selectable-row">
								<td class="gstTD">
									{{gstList.gstDataList[0]?.gstin}}
								</td>
								<td class="gstDataListTD">
									{{gstList.gstDataList[0]?.name}}
								</td>
								<td  class="addressTd">
									{{gstList.gstDataList[0]?.address}}
								</td>
								<td class="cityNameTD">
									{{gstList.gstDataList[0]?.cityname}}
								</td>
								<td class="stateNameTD">
									{{gstList.gstDataList[0]?.statename}}
								</td>
								<td class="zipcodeTD">
									{{gstList.gstDataList[0]?.zipcode}}
								</td>
								<td class="createTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{gstList?.created_at | date: 'dd-MM-yyyy'}}
								</td>
								<td class="actionTD p-frozen-column">
										<ul class="actionList">
										<li *ngIf="gstList.invoiceFile">
											<button (click)="downloadPdf(gstList.invoiceFile)"
												class="editBtn"> <i class="pi pi-file-pdf"></i></button>
										</li> 
									</ul> 
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">No GST Sales Data found.</td>
							</tr>
						</ng-template>
						<!-- <ng-template pTemplate="summary">
							<div class="p-d-flex p-ai-center p-jc-between">
								In total there are {{totalRecords }} GST records.
							</div>
						</ng-template> -->
					</p-table>
				</div>
			</div>
		</div>

	</div>
</div>


<div class="p-grid table-demo">
	<div class="p-col-12">
		<div class="card">
			<p-toast key="toastmsg"></p-toast>
			<h3></h3>
			<p-toolbar styleClass="p-mb-4">
				<ng-template pTemplate="left">
					<button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
						icon="pi pi-filter-slash" (click)="clear()
					"></button>
				</ng-template>
				<ng-template pTemplate="right">
					<button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
						class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
					<!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
				</ng-template>
			</p-toolbar> 
		</div>
		
	</div>
</div>

<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>